import type { ComponentMode, PackagingModel } from 'types';

interface State extends PackagingModel {
  mode: ComponentMode;
  defaultName: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_PACKAGING_MODEL_CATEGORIES';
      payload: Pick<typeof initialState, 'categories'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
